import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    card: {
      fontSize: 14,
      paddingTop: 14,
      paddingBottom: 21,
      marginBottom: 0,

      '&:hover': {
        '& svg': {
          opacity: '50%',
        },
      },
    },
    message: {
      textAlign: 'start',
      paddingLeft: 8,
    },
    title: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    time: {
      color: variables.black50,
      fontSize: 16,
    },
    status: {
      height: 19,
      borderRadius: 4,
      paddingRight: 4,
      paddingLeft: 4,
      boxShadow: 'none',
      fontSize: 12,
      width: 'fit-content',
      backgroundColor: '#3BBB7A',
      color: variables.white,
      alignContent: 'center',
    },
    accordionDetails: {
      flexDirection: 'column',
      padding: 0,
      border: 'none',
    },
    detailsRow: {
      '&:hover': {
        backgroundColor: variables.white,
        borderRadius: 8,
      },
    },
    detailsItem: {
      height: 35,
      paddingTop: 8,
      paddingRight: 16,
      paddingBottom: 8,
      paddingLeft: 16,
    },
    columnName: {
      fontWeight: 400,
      fontSize: 16,
      textAlign: 'left',
      color: variables.black50,
    },
    columnValue: {
      fontWeight: 600,
      fontSize: 16,
      textAlign: 'right',
      color: variables.richBlack,
    },
  }),
);
